import {CompetitorPlayerStatsModuleSportModel} from "./competitor-player-stats.module.sport-model";
import {override} from "mobx";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import {EventChartCourtRequestParams} from "../../../../core/icons/images/court/event-chart.court.request-params";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";

export class CompetitorPlayerStatsModuleFootballModel extends CompetitorPlayerStatsModuleSportModel {
  @override get shouldRenderAnimation(): Number {
    return true;
  }

  @override get shouldRenderSelector(): Number {
    return true;
  }

  @override get contextClassName(): Number {
    return styles.football
  }

  @override get courtRatio(): Number {
    return COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.COURT_RATIO.football
  }

  @override get courtType(): Number {
    return EventChartCourtRequestParams;
  }
}